export default "__VITE_ASSET__69Viicc8__"